export const DELETE_COMMENT_BY_ID = 'DELETE_COMMENT_BY_ID'
export const DELETE_COMMENT_BY_ID_PENDING = 'DELETE_COMMENT_BY_ID_PENDING'
export const DELETE_COMMENT_BY_ID_FULFILLED = 'DELETE_COMMENT_BY_ID_FULFILLED'
export const DELETE_COMMENT_BY_ID_REJECTED = 'DELETE_COMMENT_BY_ID_REJECTED'

export const CREATE_COMMENT = 'CREATE_COMMENT'
export const CREATE_COMMENT_PENDING = 'CREATE_COMMENT_PENDING'
export const CREATE_COMMENT_FULFILLED = 'CREATE_COMMENT_FULFILLED'
export const CREATE_COMMENT_REJECTED = 'CREATE_COMMENT_REJECTED'

export const EDIT_COMMENT_BY_ID = 'EDIT_COMMENT_BY_ID'
export const EDIT_COMMENT_BY_ID_PENDING = 'EDIT_COMMENT_BY_ID_PENDING'
export const EDIT_COMMENT_BY_ID_FULFILLED = 'EDIT_COMMENT_BY_ID_FULFILLED'
export const EDIT_COMMENT_BY_ID_REJECTED = 'EDIT_COMMENT_BY_ID_REJECTED'

export const GET_COMMENTS = 'GET_COMMENTS'
export const GET_COMMENTS_PENDING = 'GET_COMMENTS_PENDING'
export const GET_COMMENTS_FULFILLED = 'GET_COMMENTS_FULFILLED'
export const GET_COMMENTS_REJECTED = 'GET_COMMENTS_REJECTED'

export const CLEAR_COMMENTS = 'CLEAR_COMMENTS'
